import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import peticionBack from "../../libs/peticiones/peticionBack";
import { Panel } from "rsuite";
import { Row, Col, Button } from "react-bootstrap";
import { toaster } from "rsuite";
import FormSearch from "./FormSearch";
import TableElasticSearch from "./TableElasticSearch";
import createURL from "../../libs/peticiones/url";
import { ModalVideo } from "./components/ModalVideo";
import Alert from "../notification/Alert";
import { TypeDocument } from "../../enums/TypeDocument.enum";

const formSchema = Yup.object().shape({
  textToSearch: Yup.string().required("Seleccione el texto a buscar"),
});

export default function SearchView({
  typeDocument,
  className,
  amnistia = false,
}: {
  typeDocument?: string;
  className?: string;
  amnistia?: boolean
}) {
  const [refresh, setRefresh] = useState<boolean>(false);
  const [searching, setSearching] = useState<boolean>(false);
  const [textSearched, setTextSearched] = useState<string>("");
  const [showForm, setShowForm] = useState<boolean>(false);
  const [showModalVideo, setShowModalVideos] = useState<boolean>(false);
  const [typeSearch, setTypeSearch] = useState<"terms" | "match">("match");

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    values,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: {
      textToSearch: "",
      startDate: "",
      endDate: "",
      addDates: false,
      sistema: "",
      instancia: "",
      delito: "",
      distrito: "",
      area: "",
      region: "",
      subject: "",
      folderType: "",
      tag: "",
      childhood: false,
      genre: false,
      relevantCase: false,
      isExecutorDate: false,
      intercultural: false,
      searchWithPerspectives: false,
      olderPerson: false,
      handicappedPerson: false,
      migrant: false,
      sexual: false,
      typeDocument: amnistia ? "sentencias" : (typeDocument || "sentencias"),
      year: "",
      number: "",
      epoch: "",
      jurisprudenceType: "",
    },
    validationSchema: formSchema,
    onSubmit: (values) => {
      if (values.searchWithPerspectives) {
        if (validateOneIsActive()) {
          setSearching(true);
          setRefresh(true);
          setTextSearched(values.textToSearch);
        } else {
          toaster.push(
            Alert({
              type: "warning",
              message: "Active almenos una perspectiva",
            }),
            {
              placement: "topEnd",
            }
          );
        }
      } else {
        setSearching(true);
        setRefresh(true);
        setTextSearched(values.textToSearch);
      }
    },
    onReset: () => {},
  });

  function onChange({ target }: { target: any }) {
    if (target.name === "startDate") {
      setFieldValue("endDate", "");
    }
    setFieldValue(target.name, target.value);
  }

  async function getData(records: number, page: number) {
    let params: Array<{ name: string; value: string | number }> = [
      { name: "search", value: values.textToSearch },
      { name: "typeSearch", value: typeSearch },
      {
        name: "typeDocument",
        value: values.typeDocument,
      },
      { name: "size", value: records },
      { name: "from", value: page },
    ];

    if(amnistia && values.typeDocument === "sentencias"){
      params.push({ name: "folderType", value: values.folderType });
    }

    if (showForm) {
      if (values.sistema) {
        params.push({ name: "system", value: values.sistema });
      }
      if (values.instancia) {
        params.push({ name: "instancia", value: values.instancia });
      }
      if (values.delito) {
        params.push({ name: "judgments", value: values.delito });
      }
      if (values.startDate) {
        params.push({ name: "startDate", value: values.startDate });
      }
      if (values.endDate) {
        params.push({ name: "endDate", value: values.endDate });
      }
      if (values.distrito) {
        params.push({ name: "district", value: values.distrito });
      }
      if (values.area) {
        params.push({ name: "area", value: values.area });
      }
      if (values.region) {
        params.push({ name: "region", value: values.region });
      }
      if (values.subject) {
        params.push({ name: "subject", value: values.subject });
      }
      if (values.folderType && !amnistia) {
        params.push({ name: "folderType", value: values.folderType });
      }
      if (values.tag) {
        params.push({ name: "tag", value: values.tag });
      }
      // if (values.tag) {
      //   params.push({ name: "tag", value: values.tag });
      // }
      if (values.number) {
        params.push({ name: "number", value: values.number });
      }
      if (values.year) {
        params.push({ name: "year", value: values.year });
      }
      if (values.jurisprudenceType) {
        params.push({
          name: "jurisprudenceType",
          value: values.jurisprudenceType,
        });
      }
      if (values.isExecutorDate) {
        params.push({
          name: "isExecutorDate",
          value: JSON.stringify(values.isExecutorDate),
        });
      }
      if (values.searchWithPerspectives) {
        params.push({
          name: "childhood",
          value: JSON.stringify(values.childhood),
        });
        params.push({ name: "genre", value: JSON.stringify(values.genre) });
        params.push({
          name: "relevantCase",
          value: JSON.stringify(values.relevantCase),
        });
        params.push({
          name: "intercultural",
          value: JSON.stringify(values.intercultural),
        });
        params.push({
          name: "sexual",
          value: JSON.stringify(values.sexual),
        });
        params.push({
          name: "olderPerson",
          value: JSON.stringify(values.olderPerson),
        });
        params.push({
          name: "migrant",
          value: JSON.stringify(values.migrant),
        });
        params.push({
          name: "handicappedPerson",
          value: JSON.stringify(values.handicappedPerson),
        });
      }
    }

    const searchString = params.filter((p => p.value !== "")).map((p) => `${p.name}=${p.value}`).join('&');
    fetch("https://traductorsentenciasbk.pjedomex.gob.mx/api/buscar_sp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        datosBusqueda: searchString,
      })
    }).catch((error) => {
      console.error("Error al enviar la búsqueda a la API:", error);
    });

    const url = createURL("/files/search/elastic", params);
    return await peticionBack({}, url, "GET", false, toaster, false);
  }

  function validateOneIsActive() {
    return (
      values.childhood ||
      values.relevantCase ||
      values.intercultural ||
      values.sexual ||
      values.olderPerson ||
      values.migrant ||
      values.genre ||
      values.handicappedPerson
    );
  }

  return (
    <Panel
      shaded
      bordered
      bodyFill
      style={{
        // display: "block",
        position: "relative",
        width: "100%",
        padding: 50,
        background: "white",
      }}
      className={className ? className : ""}
    >
      {showModalVideo && (
        <ModalVideo modal={showModalVideo} setModal={setShowModalVideos} />
      )}
      <Row className="mb-3">
        <Col className="text-center">
          <div style={{ textAlign: "justify" }}>
            <div style={{ textAlign: "justify" }}>
            {typeDocument === undefined ? (
              <h5>
                El Sistema de Búsqueda de Sentencias, Acuerdos y Jurisprudencias del Estado de México es
                una plataforma digital diseñada para ofrecer acceso rápido y confiable a sentencias públicas,
                acuerdos y jurisprudencias emitidas por el Poder Judicial del Estado de México. Este sistema
                ha sido desarrollado con el objetivo de promover la transparencia, eficiencia y acceso a la
                información dentro del ámbito judicial.
              </h5>
            ) : (
              <h5>
                El Sistema de Búsqueda de Sentencias y Jurisprudencia del Estado de México es una plataforma 
                digital diseñada para ofrecer acceso rápido y confiable a 
                {amnistia 
                  ? " resoluciones de amnistía emitidas " 
                  : typeDocument === TypeDocument.SENTENCIAS 
                  ? " sentencias públicas emitidas " 
                  : typeDocument === TypeDocument.ACUERDOS 
                  ? " acuerdos emitidos " 
                  : " jurisprudencias emitidas "}
                por el Poder Judicial del Estado de México. Este sistema ha sido desarrollado con el objetivo 
                de promover la transparencia, eficiencia y acceso a la información dentro del ámbito judicial.
              </h5>
            )}
          </div>
          </div>

          <Button onClick={() => setShowModalVideos(true)}>
            Mostrar Video Tutorial
          </Button>
        </Col>
      </Row>
      <div className=" pt-3 mb-3 border">
        <form onSubmit={handleSubmit} onReset={handleReset}>
          <FormSearch
            values={values}
            touched={touched}
            errors={errors}
            onChange={onChange}
            handleBlur={handleBlur}
            showForm={showForm}
            setShowForm={setShowForm}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            typeSearch={typeSearch}
            setTypeSearch={setTypeSearch}
            reset={resetForm}
            typeDocument={typeDocument}
            amnistia={amnistia}
            onClearResults={() => {
              setSearching(false);
              setTextSearched("");
            }}
          />
        </form>
      </div>

      {/* {searching && ( */}
      <TableElasticSearch
        key={values.typeDocument}
        petition={getData}
        stateRefresh={[refresh, setRefresh]}
        textSearch={textSearched}
        searching={searching}
        setSearching={setSearching}
        initialTypeDocument={typeDocument}
      />
      {/* )} */}
    </Panel>
  );
}
